import { render, staticRenderFns } from "./OptimizeRoute.vue?vue&type=template&id=d81af84a&scoped=true&"
import script from "./OptimizeRoute.vue?vue&type=script&lang=js&"
export * from "./OptimizeRoute.vue?vue&type=script&lang=js&"
import style0 from "./OptimizeRoute.vue?vue&type=style&index=0&id=d81af84a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81af84a",
  null
  
)

component.options.__file = "OptimizeRoute.vue"
export default component.exports